import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError, timeout } from 'rxjs/operators';
import { Constant } from '../constant';

var jsonResponse: any;
@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  httpOptions = {
    headers:new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }

  constructor(private http:HttpClient , private constant : Constant) {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    headers = headers.set('Authorization', 'Bearer ' + localStorage.getItem('access_token'));
    this.httpOptions.headers = headers;
   }


  // Get device list
  getListRoundReport(date:any, agency:any): Observable<any> {
    var request = {
      "date": date,
      "agency_id": agency
    };

    return this.http.post<any>(
      `${this.constant.API_DOMAIN}/api/v1/dashboard`,
      request,this.httpOptions
      ).pipe(retry(1), catchError(this.handleError));
  }
  getDashbordChart(req:any): Observable<any> {

    return this.http.post<any>(
      `${this.constant.API_DOMAIN}/api/v1/dashboard/chart`,
      req,this.httpOptions
      ).pipe(retry(1), catchError(this.handleError));
  }

  getLastAgencyUpdate(agency:any): Observable<any> {
    return this.http.get<any>(
      `${this.constant.API_DOMAIN}/api/v1/dashboard/${agency}`,
      ).pipe(retry(1), catchError(this.handleError));
  }
   // Error handling
   handleError(error) {
    let errorMessage = '';
    if(error.error instanceof ErrorEvent) {
    // Get client-side error
    errorMessage = error.error.message;
    } else {
    // Get server-side error
    errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    //window.alert(errorMessage);
    return throwError(error);
    }
}
